import {RouteConfig} from "vue-router";
const UserHome = () => import('../views/user/UserHome.vue');
const UserData = () => import('../views/user/UserData.vue');
const UserMail = () => import('../views/user/UserMail.vue');
const UserChangePassword = () => import('../views/user/UserChangePassword.vue');
const UserTwoFactor = () => import('../views/user/UserTwoFactor.vue');
const UserIntegrationSteam = () => import('../views/user/UserIntegrationSteam.vue');
const UserIntegrationTwitch = () => import('../views/user/UserIntegrationTwitch.vue');
const UserNotification = () => import('../views/user/UserNotification.vue');
const UserNotificationMail = () => import('../views/user/UserNotificationMail.vue');

let user: RouteConfig[] = [
    {
        name: 'user',
        path: '/user',
        component: UserHome,
        redirect: {name: 'user-data'},
        children: [
            {
                name: 'user-data',
                path: '/user/data',
                component: UserData,

            },
            {
                name: 'user-mail',
                path: '/user/mail',
                component: UserMail,
            },
            {
                name: 'user-change-password',
                path: '/user/change-password',
                component: UserChangePassword,
            },
            {
                name: 'user-two-factor',
                path: '/user/two-factor',
                component: UserTwoFactor,
            },
            {
                name: 'user-integration-steam',
                path: '/user/integration/steam',
                component: UserIntegrationSteam,
            },
            {
                name: 'user-integration-twitch',
                path: '/user/integration/twitch',
                component: UserIntegrationTwitch,
            },
            {
                name: 'user-notification',
                path: '/user/notification/index',
                component: UserNotification,
            },
            {
                name: 'user-notification-mail',
                path: '/user/notification/mail',
                component: UserNotificationMail,
            }
        ]
    },
];

export default user;
